import { Button, Layout, Tag } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { formatDate, formatDescriptionWithZip } from 'core/presenters/stopPresenter'
import { StopsTimeline } from 'core/ui/components/stop/StopsTimeline'

import { LastLocation } from './LastLocation'
import { type ShipmentCardProps } from './ShipmentCard'
import { ShipmentIdentifiers } from './ShipmentIdentifiers'

export function ShipmentCardMobile({
  shipment,
  getActionLabel,
  getIdentifiers,
  getStatus,
  onActionClick,
}: ShipmentCardProps) {
  const actionLabel = getActionLabel?.()
  const identifiers = getIdentifiers?.()
  const { label, variant } = getStatus?.() ?? {}
  const { stops } = shipment

  function handleOnActionClick(event: React.MouseEvent) {
    event.stopPropagation()
    onActionClick?.()
  }

  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderRadius="border-radius-s"
      borderWidth="border-thin"
      borderColor="color-border"
      padding="none"
      style={{ display: 'block' }}
      data-testid="shipment-card-mobile"
    >
      <Layout.Stack gap="spacing-4" style={{ padding: getToken('spacing-4') }}>
        <Layout.Group justify="space-between">
          <Tag variant={variant}>{label}</Tag>
          <ShipmentIdentifiers identifiers={identifiers} />
        </Layout.Group>
        <StopsTimeline
          stops={stops}
          titleFormatter={formatDescriptionWithZip}
          subTitleFormatter={formatDate}
          compact
        />
        {actionLabel && (
          <Button variant="secondary" type="button" onClick={handleOnActionClick}>
            {actionLabel}
          </Button>
        )}
      </Layout.Stack>
      <LastLocation shipment={shipment} />
    </Layout.Box>
  )
}
